<template>
  <div>
    <cur-location :location="location" v-if="!global.isPhone()"/>
    <div>
        <div class="searchForm searchForm2">
            <div :class="!global.isPhone()?'container clearfix shadowbox':'container clearfix' "  style="background-color: #ffffff;">
                <div class="item clearfix">
                    <span class="title">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</span>
                    <div class="input">
                        <input type="text" id="name" v-model="cert.name">
                    </div>
                </div>
                <div class="item clearfix">
                    <span class="title">身份证号</span>
                    <div class="input">
                        <input type="text" v-model="cert.id">
                    </div>
                </div>
                <div class="item clearfix">
                    <span class="title">编号</span>
                    <div class="input">
                        <input type="text" v-model="cert.code">
                    </div>
                </div>
                <input type="submit" @click="inqCert()" value="查询" class="submitBtn">
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
import { Message } from "element-ui";
import CurLocation from '../components/PublicComs/CurLocation.vue';
export default {
  metaInfo: {
    meta: [
      { name:'viewport', content:
      `width=device-width, user-scalable=yes, initial-scale=${1}, maximum-scale=${1}, minimum-scale=${1}`}
    ]
  },
  props: {},
  components: {CurLocation},
  data() {
    return {
      global,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      certs: [],
      cert: {
        name: "",
        code: "",
        id: "",
      },
      form: {
        code: "",
      },
      type: "",
      location: {
        name: "信息查询",
        xname:" 测评查询",
        link: "/",
        type: "info",
      },
      certtype:''
    };
  },
  //创建前设置
  beforeCreate() {
  },
  //销毁前清除
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
    window.removeEventListener("keydown", this.keyDown, false);
  },
  created() {
    if(this.$route.query.type=='zydj'){
      this.certtype = this.$route.query.type
      this.location.xname = '等级查询'
    }
  },

  methods: {
    inqCert() {
      let url = "/api/certificates1/userget?";
      if( this.certtype=='zydj')
      {
        url = "/api/certificates2/userget?";
      }
      if (this.cert.name) url += `name=${this.cert.name.trim()}`;
      else {
        Message.error("请输入姓名！");
        return;
      }
      if (this.cert.id) url += `&cardid=${this.cert.id.trim()}`;
      if (this.cert.code) url += `&certid=${this.cert.code.trim()}`;
      this.$axios.get(encodeURI(url)).then((res) => {
        if (res.data.success == true && res.data.data.length > 0) {
          if (res.data.data.length > 1) {
            this.certs = res.data.data;
            this.dialogFormVisible = true;
            return this.$router.replace(
              encodeURI(
                `/certResult/?name=${this.cert.name.trim()}&code=${
                  res.data.data[0].certid
                }&type=${this.certType}&certtype=${this.certtype}`
              )
            );
          } else {
            return this.$router.replace(
              encodeURI(
                `/certResult/?name=${this.cert.name.trim()}&code=${
                  res.data.data[0].certid
                }&type=${this.certType}&certtype=${this.certtype}`
              )
            );
          }
        } else {
          return Message.error("无法查询到此信息，请确认信息是否填写正确！");
        }
      });
    },
    toResultPage() {
      this.cert.code = this.form.code;
      if (this.certType == "company") {
        return this.$router.replace(
          `/comCertResult/?certtype=${this.certtype}&name=${this.cert.name.trim()}&code=${this.cert.code.trim()}&type=${
            this.certType
          }`
        );
      }
      return this.$router.replace(
        `/certResult/?certtype=${this.certtype}&name=${this.cert.name.trim()}&code=${this.cert.code.trim()}&type=${
          this.certType
        }`
      );
    },
    keyDown(e) {
      //如果是按回车则执行登录方法
      if (e.keyCode == 13) {
        this.inqCert();
      }
    },
  },

  computed: {},

  mounted() {
    window.addEventListener("keydown", this.keyDown);
    if (this.$route.params.id == "qy") {
      this.type = "company";
      this.certType = "company";
    } else {
      this.type = "person";
      this.certType = "person";
    }
  },
  watch: {},
};
</script>
<style scoped>

.shadowbox{
max-width: 400px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 40px;
}
.searchForm .item{
      margin-bottom: 14px;
}

</style>
